import { render, staticRenderFns } from "./serviceEvaluation.vue?vue&type=template&id=dec3468a&scoped=true&"
import script from "./serviceEvaluation.vue?vue&type=script&lang=js&"
export * from "./serviceEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./serviceEvaluation.vue?vue&type=style&index=0&id=dec3468a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec3468a",
  null
  
)

export default component.exports